
  export default {
    async mounted() {
      const lat = parseFloat(this.el.dataset.lat);
      const lng = parseFloat(this.el.dataset.lng);
      const buildingName = this.el.dataset.buildingName;
      const t = (key) => window.I18n[key];
      const noCoordinates = t("No location coordinates available");
      const failedToLoadMap = t("Failed to load map");
      const transitLabel = t("🚇 Transit");

      if (!lat || !lng) {
        this.el.innerHTML = `<div class="flex items-center justify-center h-full text-gray-400">${noCoordinates}</div>`;
        return;
      }

      try {
        await window.Enaia.loadGoogleMaps();

        const map = new google.maps.Map(this.el, {
          zoom: 16,
          minZoom: 3,
          backgroundColor: "#e8eef1",
          center: { lat, lng },
          mapTypeControl: true,
          mapTypeControlOptions: {
            position: google.maps.ControlPosition.TOP_RIGHT,
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
          },
          streetViewControl: true,
          streetViewControlOptions: {
            position: google.maps.ControlPosition.RIGHT_TOP,
          },
          fullscreenControl: true,
          fullscreenControlOptions: {
            position: google.maps.ControlPosition.RIGHT_TOP,
          },
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_CENTER,
          },
          styles: window.Enaia?.GoogleMapsStyles?.DESATURATED_MAP_STYLES || [],
        });

        // SVG circle marker matching survey map style
        const markerColor = this.el.dataset.markerColor || "#0086e6";
        const tourStatus = this.el.dataset.tourStatus;
        const radius = 14;
        const strokeWidth = 2.5;
        const size = Math.ceil((radius + strokeWidth) * 2);
        const center = size / 2;

        // Heroicons micro paths for tour status icons
        const CHECK_PATH = "M12.416 3.376a.75.75 0 0 1 .208 1.04l-5 7.5a.75.75 0 0 1-1.154.114l-3-3a.75.75 0 0 1 1.06-1.06l2.353 2.353 4.493-6.74a.75.75 0 0 1 1.04-.207Z";
        const CALENDAR_PATH = "M4 1.75a.75.75 0 0 1 1.5 0V3h5V1.75a.75.75 0 0 1 1.5 0V3a2 2 0 0 1 2 2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2V1.75ZM4.5 6a1 1 0 0 0-1 1v4.5a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1V7a1 1 0 0 0-1-1h-7Zm.75 2.75A.75.75 0 0 1 6 8h.01a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75ZM8 8a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5H8Zm2.25.75A.75.75 0 0 1 11 8h.01a.75.75 0 0 1 0 1.5H11a.75.75 0 0 1-.75-.75ZM6 10a.75.75 0 0 0 0 1.5h.01a.75.75 0 0 0 0-1.5H6Zm2.25.75A.75.75 0 0 1 9 10h.01a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75Z";

        let iconHtml = "";
        if (tourStatus === "completed" || tourStatus === "scheduled") {
          const iconPath = tourStatus === "completed" ? CHECK_PATH : CALENDAR_PATH;
          const iconScale = (size * 0.5) / 16;
          const iconOffset = (size - 16 * iconScale) / 2;
          iconHtml = `<g transform="translate(${iconOffset}, ${iconOffset}) scale(${iconScale})"><path fill="white" fill-rule="evenodd" clip-rule="evenodd" d="${iconPath}"/></g>`;
        }

        const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
          <defs><filter id="ds" x="-20%" y="-20%" width="140%" height="140%"><feDropShadow dx="0" dy="1" stdDeviation="1.5" flood-color="#000" flood-opacity="0.25"/></filter></defs>
          <circle cx="${center}" cy="${center}" r="${radius}" fill="${markerColor}" fill-opacity="0.95" stroke="#fff" stroke-width="${strokeWidth}" filter="url(#ds)"/>${iconHtml}
        </svg>`;
        new google.maps.Marker({
          position: { lat, lng },
          map,
          title: buildingName,
          icon: {
            url: "data:image/svg+xml;charset=UTF-8," + encodeURIComponent(svg),
            scaledSize: new google.maps.Size(size, size),
            anchor: new google.maps.Point(center, center),
          },
        });

        // Transit layer with toggle button
        const transitLayer = new google.maps.TransitLayer();
        let transitEnabled = false;

        const transitBtn = document.createElement("button");
        transitBtn.innerHTML = transitLabel;
        transitBtn.className = "transit-toggle-btn";
        transitBtn.style.cssText = `
          background: white;
          border: none;
          border-radius: 2px;
          box-shadow: rgba(0,0,0,0.3) 0 1px 4px -1px;
          margin: 10px;
          padding: 8px 12px;
          font-size: 14px;
          cursor: pointer;
          font-family: Roboto, Arial, sans-serif;
        `;

        transitBtn.addEventListener("click", () => {
          transitEnabled = !transitEnabled;
          transitLayer.setMap(transitEnabled ? map : null);
          transitBtn.style.background = transitEnabled ? "#e8f5e9" : "white";
          transitBtn.style.fontWeight = transitEnabled ? "bold" : "normal";
        });

        map.controls[google.maps.ControlPosition.TOP_LEFT].push(transitBtn);
      } catch (error) {
        console.error("Error loading Google Maps:", error);
        this.el.innerHTML = `<div class="flex items-center justify-center h-full text-red-500">${failedToLoadMap}</div>`;
      }
    },

    destroyed() {
      // Cleanup if needed
    }
  }
